export default __webpack_public_path__ + "static/media/rendering_in_progress.ea62c8de.mp4";